export default __webpack_public_path__ + "static/icon-35-6-88e945bc43ffcddcb084044bd7d850c2.png";